
import React, { useState, useEffect } from 'react';
import {
    TextField, Button, InputLabel, MenuItem, FormControl, Select, Box, FormHelperText, Autocomplete
} from '@mui/material';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import MainTable from '../../../components/Table/PaginationTable.js';
import ViewShipment from "./ViewShipment";
import { ACTION } from '../../../helpers/commonName.js';
import { stockLotTableColumnDef, selectedStockLotTableColumnDef } from '../columns/ColumnDefShipment.js'
import { fetchStocks, fetchStockById, fetchStocksByShipmentProductId, deleteShipmentProductLot } from '../../../redux/shipmentSlice.js'
import EditLotShipmentModalComponent from '../../../components/Modals/EditLotShipmentModalComponent.js';

const AddLot = ({ onSubmit, shipmentProductId, shipmentId, actionType, productCount, handlePrevious, handleNext, currentStep }) => {
    const dispatch = useDispatch()
    const shipmentProducts = useSelector(state =>
        state.shipment.shipmentDetails && state.shipment.shipmentDetails.data
            ? state.shipment.shipmentDetails.data.shipmentProducts
            : []);
    const shipmentProductStocks = useSelector(state =>
        state.shipment.stockData);
    // console.log("shipmentProducts in addproduct", shipmentProducts);
    // console.log("shipmentProductStocks in addproduct", shipmentProductStocks);

    const initialValues = shipmentProducts?.find(product => product.shipmentProductId === shipmentProductId)
    // console.log("INITIALVALUESSS", initialValues);
    const [isSelectStockLotTableOpen, setIsSelectStockLotTableOpen] = useState(false);
    const [isEditLotShipmentModalOpen, setIsEditLotShipmentModalOpen] = useState(false);
    const [lotCount, setLotCount] = useState(0);
    const [pageNumber, setPageNumber] = useState(1); //  1-based indexing
    const [pageSize, setPageSize] = useState(5);
    const [selectedStock, setSelectedStock] = useState(null);
    const [shipmentProductLotId, setShipmentProductLotId] = useState(null);
    const totalRecords = useSelector(state => state.shipment?.stockTotalRecords) || 0;
    // console.log("totalRecords", totalRecords);

    const product = {
        productName: initialValues?.productName || '',
        productUom: initialValues?.productUom || '',
        productQty: initialValues?.productQty || '',
        productDescription: initialValues?.productDescription || '',
        shipmentProductLotNo: initialValues?.shipmentProductLotNo || '',
        blendPercentage: initialValues?.blendPercentage || '',
    };

    // console.log("product", product, "actuil", actionType);
    const stockList = useSelector((state) => state.shipment.stockList || []);
    const stockDetails = useSelector((state) => state.shipment.stockDetails || []);

    const onPageIndexChange = (newPageIndex) => {
        // console.log("newPageIndex", newPageIndex);
        setPageNumber(newPageIndex);
    };

    useEffect(() => {
        const queryParams = {
            searchText: '',
            pageSize,
            pageNumber,
        };
        // console.log("inside handleSelectStockLotClick!!");
        dispatch(fetchStocks(queryParams))
    }, [dispatch, pageNumber]);

    useEffect(() => {
        dispatch(fetchStocksByShipmentProductId(shipmentProductId))
            .then("inside fetchStocksByShipmentProductId lotcount", lotCount)
    }, [dispatch, lotCount]);

    const updateLotCount = () => {
        setLotCount(lotCount + 1);
        setIsSelectStockLotTableOpen(false);
        // if(shipmentProductLotId){ // If block runs when we click edit quantity, to keep exact count of lot, we can remove it if not req.
        //     setLotCount(lotCount-1);
        // } 
        // console.log("lot count", lotCount)
    }

    const handleSelectStockLotClick = () => {
        // console.log("inside handleSelectStockLotClick!!");
        setIsSelectStockLotTableOpen(true);
    }

    const handleAddStockLot = (data) => {
        setShipmentProductLotId('');
        setSelectedStock(data);
        setIsEditLotShipmentModalOpen(true)
    }

    const handleEditLotQty = (data) => {
        setShipmentProductLotId(data.shipmentProductLotId)
        dispatch(fetchStockById(data.stock.stockLotId))
            .then((response) => {
                // console.log("response11",response.payload.data[0],"STOCKDETAILS",stockDetails)
                setSelectedStock(response.payload.data[0]);
                setIsEditLotShipmentModalOpen(true)
            })
    }

    const handleDeleteStockLot = (data) => {
        // console.log(shipmentProductLotId,"shipmentProductLotId in delete")
        dispatch(deleteShipmentProductLot({ shipmentId, shipmentProductLotId: data.shipmentProductLotId }))
            .then((response) => {
                setLotCount(lotCount - 1);
                // console.log("response11",response,"LOT DELETED SUCCESSFULLY")
            })
    }

    const onEditLotShipmentModalClose = () => {
        setIsEditLotShipmentModalOpen(false)
    }

    const stockLotColumnDef = stockLotTableColumnDef(handleAddStockLot);
    const selectedStockLotColumnDef = selectedStockLotTableColumnDef(handleEditLotQty, handleDeleteStockLot);

    return (
        <div className="main-content">
            <nav aria-label="breadcrumb" class="bread-box">
                <div>
                    <h1 className="fprimary">Add Lot</h1>
                    <h5 className="">Add Lot details</h5>
                </div>
                <div>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="#">Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Add Lot</li>
                    </ol>
                </div>
            </nav>
            <div className="bad-box py-3">
                <span class="badge bg-danger red-bages">Please note: Kindly fill in all details in English characters only and within character limits as specified below.</span>
            </div>
            <div className="card mt-3 bg-stage bg-dot">
                <div className="card-body">
                    <Formik
                        // initialValues={initialValues}
                        initialValues={product}
                    // enableReinitialize
                    // validationSchema={productSchema}
                    // onSubmit={(values, { setSubmitting }) => {
                    //     const formattedValues = {
                    //         ...values,
                    //         // orderDate: dayjs(values.orderDate).format('YYYY-MM-DD'),
                    //         // orderExpectedDate: dayjs(values.orderExpectedDate).format('YYYY-MM-DD'),
                    //     };
                    //     console.log('Formatted Submit:', formattedValues);
                    //     onSubmit(formattedValues);
                    //     setSubmitting(false);
                    //     // if(isNext === true){
                    //     // } else
                    //     if (actionType === ACTION.ADD) {
                    //         resetForm(values); // Optionally reset the form only on add action
                    //     } else if(actionType === ACTION.EDIT){
                    //         handleNext()
                    //     }

                    // }}
                    >
                        {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                            <form class="px-3 py-3">
                                <fieldset disabled>
                                    {/* <Box sx={{ display: 'flex', gap: 2 }}> */}
                                    <div className="row">
                                        <div className="col-md-12 cs-form mb-3">
                                            <TextField
                                                name="productName"
                                                label="Product Name"
                                                className='md-input'
                                                value={values.productName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.productName && Boolean(errors.productName)}
                                                helperText={touched.productName && errors.productName}
                                            />

                                            {/* <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                className='md-input'
                                options={productsOptions}
                                value={values.productName}
                                onChange={(event, newValue) => {
                                    handleChange({ target: { name: 'productName', value: newValue?.label || '' } });
                                }}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Product"
                                        error={!!errors.productName}
                                        helperText={errors.productName}
                                    />
                                )}
                            /> */}
                                        </div>

                                    </div>
                                    {/* </Box> */}
                                    <div className="row">

                                        {/* <Box sx={{ display: 'flex', gap: 2 }}> */}
                                        <div className="col-md-3 cs-form mb-2">
                                            <TextField
                                                name="shipmentProductLotNo"
                                                label="Finished goods lot number"
                                                className='md-input'
                                                value={values.shipmentProductLotNo}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.shipmentProductLotNo && Boolean(errors.shipmentProductLotNo)}
                                                helperText={touched.shipmentProductLotNo && errors.shipmentProductLotNo}
                                            />
                                        </div>
                                        <div className="col-md-3 cs-form mb-2">
                                            <TextField
                                                name="productQty"
                                                label="Quantity *"
                                                className='md-input'
                                                type="number"
                                                value={values.productQty}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.productQty && Boolean(errors.productQty)}
                                                helperText={touched.productQty && errors.productQty}
                                            />
                                        </div>
                                        <div className="col-md-3 cs-form mb-2">

                                            <TextField
                                                name="productName"
                                                label="Finished goods lot number"
                                                className='md-input'
                                                value={values.productUom}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.productUom && Boolean(errors.productUom)}
                                                helperText={touched.productUom && errors.productUom}
                                            />
                                        </div>
                                        <div className="col-md-3 cs-form mb-2">
                                            <TextField
                                                name="blendPercentage"
                                                label="Blend % of Birla Cellulose *"
                                                className='md-input'
                                                type="number"
                                                value={values.blendPercentage}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.blendPercentage && Boolean(errors.blendPercentage)}
                                                helperText={touched.blendPercentage && errors.blendPercentage}
                                            />
                                        </div>
                                        {/* </Box> */}
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-12 cs-form mb-6">
                                            <TextField
                                                name="productDescription"
                                                className='md-input'
                                                label="Product Description"
                                                multiline
                                                rows={4}
                                                value={values.productDescription}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched.productDescription && Boolean(errors.productDescription)}
                                                helperText={touched.productDescription && errors.productDescription}
                                                inputProps={{
                                                    maxLength: 300,
                                                }}
                                            // helperText={`${values.productDescription.length}/300`}
                                            />
                                        </div>
                                    </div>
                                    <div class="input-group mb-3">
                                        <div className="col-md-12 cs-form mb-6 mt-3">
                                        </div>
                                    </div>
                                </fieldset>
                                {/* <div className="d-flex justify-content-between mt-3">
                                    <button type="button" className="btn btn-light grey-btn lg-btn" onClick={handlePrevious}>Back</button>
                                    <div>
                                        <button type="button" className="btn btn-primary greeen-btn lg-btn me-3" onClick={handleSelectStockLotClick}>
                                            Select Stock Lot
                                        </button>
                                    </div>
                                </div> */}
                            </form>)
                        }
                    </Formik >
                    {isSelectStockLotTableOpen &&
                        <>
                            <div>
                                <h1 className="fprimary">Select Stock Lots</h1>
                                <h5 className="">Select one or more stock lots that you would like to consume for this shipment</h5>
                            </div>
                            <MainTable
                                columns={stockLotColumnDef}
                                data={stockList}
                                initialPageSize={pageSize}
                                pageNumber={pageNumber}
                                onPageIndexChange={onPageIndexChange}
                                enablePagination={true}
                                totalRecords={totalRecords} // Pass the totalRecords to MainTable
                                recordCountText="records found"
                            />
                        </>
                    }
                    {shipmentProductStocks.length !== 0 && !isSelectStockLotTableOpen &&
                        <>
                            <div>
                                <h1 className="fprimary">Selected Stock Lots</h1>
                            </div>
                            <MainTable
                                columns={selectedStockLotColumnDef}
                                data={shipmentProductStocks}
                                // initialPageSize={pageSize}
                                // pageNumber={pageNumber}
                                // onPageIndexChange={onPageIndexChange}
                                enablePagination={false}
                            // totalRecords={totalRecords} // Pass the totalRecords to MainTable
                            // recordCountText="records found"
                            />
                        </>
                    }
                    <div className="d-flex justify-content-between mt-3">
                        <button type="button" className="btn btn-light grey-btn lg-btn" onClick={handlePrevious}>Back</button>
                        <div>
                            <button type="button" className="btn btn-primary greeen-btn lg-btn me-3" onClick={handleSelectStockLotClick}>
                                Select Stock Lot
                            </button>
                            <button type="button" className="btn btn-primary greeen-btn lg-btn" onClick={handlePrevious}>Next</button>
                        </div>
                    </div>
                    {isEditLotShipmentModalOpen &&
                        <EditLotShipmentModalComponent isOpen={isEditLotShipmentModalOpen} onClose={onEditLotShipmentModalClose} shipmentId={shipmentId} stock={selectedStock} shipmentProductId={shipmentProductId} shipmentProductLotId={shipmentProductLotId} updateLotCount={updateLotCount} />
                    }
                </div>
            </div>
        </div>
    )
}
export default AddLot